export type Label = { label: string };
export type Icons =
  | "adultsOnly"
  | "beach"
  | "sandyBeach"
  | "pool"
  | "wlan"
  | "IconEco"
  | "IconPet"
  | "bed";

export type SearchFormDataRoomType = {
  byId: {
    [key in "false" | string | number]: Label;
  };
  allIds: Array<number>;
};
export type SearchFormDataMealType = {
  byId: {
    [key in MealTypeIds]: Label;
  };
  allIds: Array<MealTypeIds | false>;
};
export type SearchFormDataHotelCriteria = {
  byId: {
    [key in HotelCriteriaIds]: Label & { icon: Icons };
  };
  allIds: Array<HotelCriteriaIds>;
};
export type SearchFormDataRoomTypeCategories = {
  allIds: readonly HotelCriteriaIds[];
};
export type SearchFormDataMinRecommendation = {
  byId: {
    [key in MinRecommendationIds]: Label;
  };
  allIds: Array<MinRecommendationIds>;
};
export type SearchFormDataTopFamily = {
  byId: {
    [key in TopFamilyIds]: Label;
  };
  allIds: Array<TopFamilyIds>;
};
export type SearchFormDataTopWellness = {
  byId: {
    [key in TopWellnessIds]: Label;
  };
  allIds: Array<TopWellnessIds>;
};
export type SearchFormDataTopSport = {
  byId: {
    [key in TopSportIds]: Label;
  };
  allIds: Array<TopSportIds>;
};
export type SearchFormDataTransfer = {
  byId: {
    anything: Label & { icon: "optional-large" };
    transfer: Label & {
      icon: "bus-large";
    };
    rentalCar: Label & {
      icon: "car-large";
    };
  };
  allIds: ["anything", "transfer", "rentalCar"];
};
export type SearchFormDataRailAndFly = {
  byId: {
    1: Label & {
      icon: "train-large";
    };
  };
  allIds: [1];
};
export type SearchFormDataFlightTime = {
  byId: {
    [key in FlightTimeIds | "false"]: Label;
  };
  allIds: Array<FlightTimeIds | false>;
};
export type SearchFormDataPrice = {
  byId: {
    6000: Label;
  };
  range: {
    min: number;
    max: number;
    step: number;
    default: number;
  };
};

export type SearchFormDataState = {
  roomType: SearchFormDataRoomType;
  mealType: SearchFormDataMealType;
  hotelCriteria: SearchFormDataHotelCriteria;
  roomTypeCategories: SearchFormDataRoomTypeCategories;
  minRecommendation: SearchFormDataMinRecommendation;
  topFamily: SearchFormDataTopFamily;
  topWellness: SearchFormDataTopWellness;
  topSport: SearchFormDataTopSport;
  transfer: SearchFormDataTransfer;
  railAndFly: SearchFormDataRailAndFly;
  flightTime: SearchFormDataFlightTime;
  price: SearchFormDataPrice;
};

export type SearchFormDataValues =
  | SearchFormDataRoomType
  | SearchFormDataHotelCriteria
  | SearchFormDataMinRecommendation
  | SearchFormDataTopFamily
  | SearchFormDataTopWellness
  | SearchFormDataTopSport
  | SearchFormDataTransfer
  | SearchFormDataRailAndFly
  | SearchFormDataFlightTime
  | SearchFormDataPrice;

export enum HotelCriteriaEnums {
  beachLocation = "strandlage",
  sandyBeach = "sandstrand",
  pool = "pool",
  onlyForAdults = "nur_fur_erwachsene",
  wlan = "wlan",
  sustainable = "sustainable",
  petAllowed = "petAllowed",
  privatePool = "privatePool",
  swimupPool = "swimupPool",
  atLeastTwoSeparateBedrooms = "atLeastTwoSeparateBedrooms",
  separateBedroom = "separateBedroom",
}

export type TopFamilyIds = 19 | 21 | 22 | 20 | 23 | 77;
export type MinRecommendationIds = 70 | 80 | 85 | 90 | 95 | 100;
export type HotelCriteriaIds = 30 | 32 | 33 | 44 | 46 | 101 | 79 | 80 | 81 | 82 | 83;
export type MealTypeIds = 2 | 3 | 4 | 5;
export type TopSportIds = 12 | 7 | 5 | 4 | 9 | 17 | 16 | 34;
export type TopWellnessIds = 39 | 40;
export type FlightTimeIds = 1 | 2 | 3 | 4;

export type SearchFormDataKeys =
  | "roomType"
  | "mealType"
  | "hotelCriteria"
  | "minRecommendation"
  | "topFamily"
  | "topWellness"
  | "topSport"
  | "transfer"
  | "railAndFly"
  | "city"
  | "flightTime";

export type NullableString = string | null;

export enum TopSportsEnums {
  mountainBicycle = "fahrrad_mountanbike",
  golf = "golf",
  fitness = "fitness",
  tennisSquash = "tennis_squash",
  waterSport = "wassersport",
  surfing = "surfen",
  diving = "tauchen",
  indoorSwimmingPool = "hallenbad",
}

export enum TopFamilyEnums {
  familyFriendly = "familienfreundlich",
  childCare = "kinderbetreuung",
  animationsProgram = "animationsprogramm",
  childrenPool = "kinderpool",
  playground = "spielplatz",
  waterSlides = "wasserrutschen",
}

export enum TopWellnessEnums {
  massage = "massage",
  sauna = "sauna",
}
